"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ROW_SELECTION_TYPES = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

var _Radio = _interopRequireDefault(require("../Radio/Radio"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ROW_SELECTION_TYPES = {
  CHECKBOX: 'checkbox',
  RADIO: 'radio'
};
/**
 * RowSelection inside Table
 */

exports.ROW_SELECTION_TYPES = ROW_SELECTION_TYPES;

var TableRowSelection =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TableRowSelection, _React$Component);

  function TableRowSelection() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, TableRowSelection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TableRowSelection)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.handleCheckboxChange = function (e, rowKeyVal, isSelected, rowIndex) {
      var eventHandlers = _this.props.eventHandlers;

      if (isSelected) {
        eventHandlers.handleRowSelect(e, rowKeyVal, rowIndex);
      } else {
        eventHandlers.handleRowUnselect(e, rowKeyVal, rowIndex);
      }
    }, _this.handleRadioChange = function (rowKeyVal) {
      var eventHandlers = _this.props.eventHandlers;
      eventHandlers.handleRowSelectOne(rowKeyVal);
    }, _temp));
  }

  _createClass(TableRowSelection, [{
    key: "render",
    value: function render() {
      var type = this.props.type;

      if (type === ROW_SELECTION_TYPES.RADIO) {
        return this.renderRadio();
      }

      return this.renderCheckBox();
    }
  }, {
    key: "renderCheckBox",
    value: function renderCheckBox() {
      var _this2 = this;

      var _this$props = this.props,
          isSelected = _this$props.isSelected,
          rowIndex = _this$props.rowIndex,
          rowKeyVal = _this$props.rowKeyVal;
      return _react.default.createElement(_Checkbox.default, {
        id: rowKeyVal,
        checked: isSelected,
        onChange: function onChange(e) {
          return _this2.handleCheckboxChange(e, rowKeyVal, !isSelected, rowIndex);
        }
      });
    }
  }, {
    key: "renderRadio",
    value: function renderRadio() {
      var _this$props2 = this.props,
          isSelected = _this$props2.isSelected,
          rowKeyVal = _this$props2.rowKeyVal;
      return _react.default.createElement(_Radio.default, {
        checked: isSelected,
        value: rowKeyVal,
        onChange: this.handleRadioChange
      });
    }
    /**
     * Checkbox change event handler
     * @param {object} e - SyntheticEvent
     * @param {string} rowKeyVal - Unique key to identify row
     * @param {boolean} isSelected - Should checkbox be selected
     * @param {number} rowIndex - Index of row to be rendered
     */

  }]);

  return TableRowSelection;
}(_react.default.Component);

exports.default = TableRowSelection;
TableRowSelection.ROW_SELECTION_TYPES = ROW_SELECTION_TYPES;
TableRowSelection.defaultProps = {};
TableRowSelection.propTypes = {
  /**
   * Table event handlers
   */
  eventHandlers: _propTypes.default.object,

  /**
   * Whether or not row is selected
   */
  isSelected: _propTypes.default.bool,

  /**
   * Index of row from data source
   */
  rowIndex: _propTypes.default.number,

  /**
   * Row key value to identify row
   */
  rowKeyVal: _propTypes.default.string,

  /**
   * Type of selection
   */
  type: _propTypes.default.string
};